<app-page>
    <div class="col-12 md:col-10 lg:col-8 xl:col-7 m-auto py-2 px-3">
        <h2 class="my-3">Contact Us</h2>
        <p-card styleClass="h-full">
            <div class="pb-5 border-bottom-1 border-slate-300 border-round-bottom-xs" *ngIf="!showConfirmation">
                <div class="flex flex-column">
                    <p class="text-md m-0 mb-3">Contract number</p>
                    <h3 class="text-lg my-0" data-auto-id="contact-cinch-contract-number">{{
                        baseContractData.contractNumber }}</h3>
                </div>
                <div class="flex flex-column">
                    <p class="text-md">Address</p>
                    <h3 class="text-lg my-0" data-auto-id="contact-cinch-user-address">{{
                        baseContractData.propertyAddress.addressLine1 }}, {{
                        baseContractData.propertyAddress.city }}, {{ baseContractData.propertyAddress.state }}, {{
                        baseContractData.propertyAddress.zip }}</h3>
                </div>
            </div>
            <div class="text-slate-400 text-base line-height-3" *ngIf="!showConfirmation">
                <p [innerHTML]="entryPageContent"></p>
            </div>

            <div *ngIf="showConfirmation" class="flex flex-column gap-3">
                <p-tag role="status" aria-live="polite" severity="success"
                    styleClass="text-emerald-900 bg-emerald-100 font-normal p-2 flex-1">
                    <div class="flex gap-2 align-items-baseline">
                        <i class="pi pi-check-circle text-emerald-900 text-xs" aria-hidden="true"></i>
                        <div class="flex flex-column">
                            <p class="mb-0" [innerHTML]="confirmationPageContent"></p>
                        </div>
                    </div>
                </p-tag>

                <p-button type="button" severity="primary" [rounded]="true"
                    data-auto-id="contact-cinch-process-completed" (click)="goToDashboard()"
                    class="flex align-items-center w-full flex-order-1 md:flex-order-0 " styleClass="w-full">
                    Go back to dashboard
                </p-button>
            </div>
        </p-card>
    </div>

    <div class="col-12 md:col-10 lg:col-8 xl:col-7 m-auto py-3 px-3" *ngIf="!showConfirmation">
        <p-card styleClass="h-full">
            <div *ngIf="errorMsg" class="mb-3">
                <p-tag icon="pi pi-exclamation-triangle text-xs" severity="danger" styleClass="font-normal p-2 flex-1"
                    [value]="errorMsg" />
            </div>
            <form [formGroup]="contactForm" class="pt-4" (ngSubmit)="onSubmit(contactForm)">
                <div class="p-fieldset field">
                    <label for="contact-cinch-reason">How can we help?</label>
                    <div *ngIf="contactForm.controls['reasonForContact'].touched && contactForm.controls['reasonForContact'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <p-select inputId="contact-cinch-reason" formControlName="reasonForContact" [options]="reasonOptions" optionLabel="label"
                        optionValue="value" placeholder="Select an option" class="flex w-full" styleClass="w-full"
                        (onChange)="onReasonChange($event.value)" [loading]="isNavigatingToServiceRequest"
                        data-auto-id="contact-cinch-reason-select" aria-describedby="reason-help"
                        [attr.aria-invalid]="contactForm.controls['reasonForContact'].invalid && contactForm.controls['reasonForContact'].touched">
                    </p-select>
                    <div *ngIf="isNavigatingToServiceRequest"
                        class="flex align-items-center gap-2 mt-2 p-2 bg-blue-50 border-round text-blue-900 border-1 border-blue-200"
                        data-auto-id="contact-cinch-navigating-loader">
                        <i class="pi pi-spin pi-spinner text-primary text-base" aria-hidden="true"></i>
                        <span class="text-sm font-medium">Getting started... Please wait.</span>
                    </div>
                    <small id="reason-help"
                        *ngIf="!isNavigatingToServiceRequest && contactForm.controls['reasonForContact'].invalid && contactForm.controls['reasonForContact'].touched"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-reason-validation-error">
                        Please select how we can help
                    </small>
                </div>

                <div class="p-fieldset field" *ngIf="showExistingJobSelect">
                    <label for="contact-cinch-job-details">
                        <span class="hidden md:inline">Which service request do you need help with?</span>
                        <span class="inline md:hidden">Select a service request</span>
                    </label>
                    <div *ngIf="contactForm.controls['jobDetails'].touched && contactForm.controls['jobDetails'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <p-select inputId="contact-cinch-job-details" formControlName="jobDetails" [options]="jobOptions"
                        optionLabel="label" optionValue="value" placeholder="Select a service request"
                        class="flex w-full" styleClass="w-full" data-auto-id="contact-cinch-job-select"
                        aria-describedby="job-details-help"
                        [attr.aria-invalid]="contactForm.controls['jobDetails'].invalid && contactForm.controls['jobDetails'].touched">
                    </p-select>
                    <small id="job-details-help"
                        *ngIf="contactForm.controls['jobDetails'].invalid && contactForm.controls['jobDetails'].touched"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-job-details-validation-error">
                        Please select a service request
                    </small>
                </div>

                <div class="p-fieldset field">
                    <label for="contat-cinch-firstName">First name</label>
                    <div *ngIf="contactForm.controls['firstName'].touched && contactForm.controls['firstName'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <input id="contat-cinch-firstName" type="text" pInputText class="w-full" formControlName="firstName"
                        data-auto-id="contact-cinch-firstName" aria-describedby="firstName-help">
                    <small id="firstName-help"
                        *ngIf="contactForm.controls['firstName'].invalid && contactForm.controls['firstName'].touched"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-firstName-validation-error">
                        Please enter your first name
                    </small>
                    <small id="firstName-help" *ngIf="contactForm.controls['firstName'].errors?.['maxlength']"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-firstName-validation-error">
                        First name cannot be more than {{
                        contactForm.controls['firstName'].errors?.['maxlength'].requiredLength }}
                        characters long
                    </small>
                </div>
                <div class="p-fieldset field">
                    <label for="contat-cinch-lastName">Last name</label>
                    <div *ngIf="contactForm.controls['lastName'].touched && contactForm.controls['lastName'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <input id="contat-cinch-lastName" type="text" pInputText class="w-full" formControlName="lastName"
                        data-auto-id="contact-cinch-lastName" aria-describedby="lastName-help">
                    <small id="lastName-help"
                        *ngIf="contactForm.controls['lastName'].invalid && contactForm.controls['lastName'].touched"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-lastName-validation-error">
                        Please enter your last name
                    </small>
                    <small id="lastName-help" *ngIf="contactForm.controls['lastName'].errors?.['maxlength']"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-lastName-validation-error">
                        Last name cannot be more than {{
                        contactForm.controls['lastName'].errors?.['maxlength'].requiredLength }}
                        characters long
                    </small>
                </div>
                <div class="p-fieldset field">
                    <label for="contat-cinch-phone">Phone number</label>
                    <div *ngIf="contactForm.controls['phone'].touched && contactForm.controls['phone'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <input id="contat-cinch-phone" type="text" pInputText class="w-full" formControlName="phone"
                        data-auto-id="contact-cinch-phone" aria-describedby="phone-help">
                    <small id="phone-help"
                        *ngIf="contactForm.controls['phone'].invalid && contactForm.controls['phone'].touched"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-phone-validation-error">
                        Please enter a valid phone number
                    </small>
                </div>
                <div class="p-fieldset field">
                    <label for="contat-cinch-email">Email</label>
                    <div *ngIf="contactForm.controls['email'].touched && contactForm.controls['email'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <input id="contat-cinch-email" type="text" pInputText class="w-full" formControlName="email"
                        data-auto-id="contact-cinch-email" aria-describedby="email-help">
                    <small id="email-help"
                        *ngIf="contactForm.controls['email'].invalid && contactForm.controls['email'].touched"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-email-validation-error">
                        Please enter a valid email address
                    </small>
                </div>
                <div class="p-fieldset field">
                    <label for="contat-cinch-question">Question <small>( {{ characterLength }} characters
                            remaining)</small></label>
                    <div *ngIf="contactForm.controls['question'].touched && contactForm.controls['question'].errors?.['required']"
                        class="required text-orange-900">
                        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                    </div>
                    <textarea id="contat-cinch-question" rows="5" cols="30" maxlength="240" class="w-full"
                        formControlName="question" pTextarea data-auto-id="contact-cinch-question"
                        aria-describedby="question-help" (input)="questionCharacterlengthcalculation()"></textarea>
                    <small id="question-help"
                        *ngIf="contactForm.controls['question'].invalid && contactForm.controls['question'].touched"
                        class="mt-1 text-rose-600" data-auto-id="contact-cinch-question-validation-error">
                        Please enter your question
                    </small>
                </div>
                <div class="flex flex-column md:flex-row w-full gap-3 md:gap-4">
                    <p-button type="button" severity="secondary" [rounded]="true"
                        data-auto-id="contact-cinch-back-to-dashboard" variant="outlined"
                        [disabled]="isNavigatingToServiceRequest"
                        class="flex align-items-center justify-content-center w-full flex-order-1 md:flex-order-0 "
                        styleClass="w-full" (click)="goToDashboard()">
                        Go back to dashboard
                    </p-button> <p-button type="submit" [rounded]="true" severity="primary"
                        data-auto-id="contact-cinch-submit"
                        [disabled]="!contactForm.valid || isSubmitForm || isNavigatingToServiceRequest"
                        class="flex align-items-center justify-content-center w-full flex-order-0 md:flex-order-1"
                        styleClass="w-full">
                        <ng-container *ngIf="isSubmitForm">
                            <i class="pi pi-spin pi-spinner"></i>&nbsp;Submitting
                        </ng-container>
                        <ng-container *ngIf="!isSubmitForm"> Submit </ng-container>
                    </p-button>
                </div>
            </form>
        </p-card>
    </div>
</app-page>
